import Progress from "common/components/ui/Progress";
import Skeleton from "common/components/ui/Skeleton";

import useCampaignCompletion from "../../../datahooks/useCampaignCompletion";

export default function CampaignCompletion({ id }: { id: string }) {
  const { completion, isLoadingCompletion } = useCampaignCompletion(id);

  const value = completion ? Math.floor(completion * 100) : 0;

  return (
    <div className="flex items-center gap-x-1">
      {isLoadingCompletion ? (
        <Skeleton className="w-6 h-4" />
      ) : (
        <span className="text-button-xs">
          {typeof completion === "number" ? `${value}%` : "-"}
        </span>
      )}

      <Progress value={value} className="w-24" />
    </div>
  );
}
